module.exports = __webpack_public_path__ + "static/media/esim_graph3_en.b0432b99.png";